import { Component } from 'react';

import withInitialBreakpoint from 'core/hocs/withInitialBreakpoint';

import bind from 'core/utils/bind';
import valueEmitterFactory from 'core/utils/value-emitter';
import breakpointPropTypes from 'core/utils/prop-types/breakpoint';
import valueEmitterPropTypes from 'core/utils/prop-types/value-emitter';


import { DESKTOP } from './values';

import {
  MOBILE_SMALL,
  MOBILE_BIG,
  DESKTOP_SMALL,
  DESKTOP_BIG,
  viewportBreakpoints,
} from './viewport-values';


class BrowserBreakpoint extends Component {
  static propTypes = {
    initialBreakpoint: breakpointPropTypes(),
  };

  static childContextTypes = {
    initialBreakpoint: breakpointPropTypes(),
    viewportBreakpointEmitter: valueEmitterPropTypes,
  };

  constructor(props) {
    super(props);

    const viewportBreakpointEmitter = valueEmitterFactory();
    this.state = { viewportBreakpointEmitter };
  }

  getChildContext() {
    return {
      initialBreakpoint: this.props.initialBreakpoint,
      viewportBreakpointEmitter: this.state.viewportBreakpointEmitter,
    };
  }

  componentDidMount() {
    if (process.env.BROWSER_RUNTIME) {
      const { initialBreakpoint } = this.props;

      // Подписываемся на клиентские обновления лейаута.
      if (initialBreakpoint === DESKTOP) {
        this.matchers = {
          [DESKTOP_SMALL]: window.matchMedia(`
            only screen
            and (max-width: ${viewportBreakpoints[DESKTOP_SMALL]})
          `),

          [DESKTOP_BIG]: window.matchMedia(`
            only screen
            and (min-width: ${parseInt(viewportBreakpoints[DESKTOP_SMALL], 10) + 1}px)
          `),
        };
      } else {
        this.matchers = {
          [MOBILE_SMALL]: window.matchMedia(`
            only screen
            and (max-width: ${viewportBreakpoints[MOBILE_SMALL]})
          `),

          [MOBILE_BIG]: window.matchMedia(`
            only screen
            and (min-width: ${parseInt(viewportBreakpoints[MOBILE_SMALL], 10) + 1}px)
          `),
        };
      }

      const handler = bind(this.resolveMatchMedia, this);

      Object
        .keys(this.matchers)
        .forEach(name => {
          if (this.matchers[name].matches) {
            this.state.viewportBreakpointEmitter.set(name);
          }
          this.matchers[name].addListener(handler);
        });
    }
  }

  componentWillUnmount() {
    if (this.matchers) {
      const handler = bind(this.resolveMatchMedia, this);

      Object
        .keys(this.matchers)
        .forEach(name => this.matchers[name].removeListener(handler));
    }
  }

  resolveMatchMedia({ target, matches }) {
    if (matches) {
      const [breakpoint] = Object
        .keys(this.matchers)
        .filter(name => this.matchers[name] === target);

      this.state.viewportBreakpointEmitter.set(breakpoint);
    }
  }

  render() {
    return this.props.children;
  }
}

export default withInitialBreakpoint(BrowserBreakpoint);
